<div class="contributor-option">
  <mat-icon class="favorite-icon is-favorite" fontSet="fontastic" fontIcon="icon-ic-star"></mat-icon>
  Appliquer les favoris ({{ favoriteCount }})
</div>
